import React, { useState } from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import MonthDatePicker from 'components/common/MonthDatePicker/monthDatePicker';

import classes from 'components/Dashboards/Project/Components/DataStories/DataStoriesHeader/headerContent.module.scss';
import { Button } from 'components/DesignSystem/Button';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { CustomizedTooltip } from 'components/common';

export const HeaderContent = ({
    handleDateData,
    handleClearDate,
    onTextSearch,
    onClearSearch,
    isReadOnly,
    addStory,
    startDate,
    endDate,
}) => {
    const [datePickerTitle, setDatePickerTitle] = useState<any>('Select Date');

    const [textSearch, setTextSearch] = useState('');

    const handleChosenDate = (value) => {
        setDatePickerTitle(null);
        handleDateData(value);
    };

    const handleClearDatePicker = () => {
        setDatePickerTitle('Select Date');
        handleClearDate();
    };

    const searchInputChange = (e) => {
        setTextSearch(e.target.value);
        if (e.target.value.length === 0) {
            onClearSearch();
        }
    };

    const handleTextSearch = () => {
        onTextSearch(textSearch);
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            onTextSearch(textSearch);
        }
    };

    const handleClearSearch = () => {
        setTextSearch('');
        onClearSearch();
    };
    return (
        <div className={classes.headerContentContainer}>
            <div className={classes.searchInputWrapper}>
                <TextInput
                    id={'news-feed-search'}
                    placeholder={'Search...'}
                    value={textSearch}
                    onChange={searchInputChange}
                    onClear={handleClearSearch}
                    onKeyDown={onKeyDown}
                    searchable={true}
                    onSearch={handleTextSearch}
                />
            </div>
            <div className={classes.datePickerContainer}>
                <MonthDatePicker
                    datePickerTitle={datePickerTitle}
                    title={false}
                    placement={'bottom'}
                    staticStartDate={moment(new Date(startDate))
                        .subtract(1, 'months')
                        .format(constants.formats.date.yearMonthDay)}
                    staticEndDate={moment(new Date(endDate)).format(constants.formats.date.yearMonthDay)}
                    currentChosenDate={moment(new Date(startDate)).format(constants.formats.date.yearMonthDay)}
                    handleDateData={handleChosenDate}
                    highlight={[]}
                    disabled={false}
                    handleClearDatePicker={handleClearDatePicker}
                />
            </div>
            {isReadOnly !== false && (
                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={`Create Story`}
                    triggerElement={
                        <Button disableRipple size={'small'} variant={'primary'} onClick={addStory}>
                            <MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />
                        </Button>
                    }
                />
            )}
        </div>
    );
};
